import React from 'react';
import WebinarForm from './form';
import Segment from '../shared/segment';
import icons from './icons';

const Webinar: React.FC = () => {
  return (
    <div className='bg-zinc-100 text-justify font-sans text-slate-900' dir='rtl'>
      {/* Top Banner */}
      <Segment
        bg
        color='teal'
        className='top-0 py-4 px-4 text-center text-teal-700 shadow-lg sm:py-6'
      >
        <div className='flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-3'>
          <h1 className='text-lg font-black leading-tight md:text-2xl'>
            تخفیف ویژه آزمون‌های دستیاری ۱۴۰۶ برای شرکت‌کنندگان وبینار
          </h1>
        </div>
      </Segment>

      <main className='mx-auto max-w-4xl space-y-12 px-4 py-8 sm:space-y-16 sm:px-6 sm:py-12'>
        {/* Wellcome Section */}
        <section className='space-y-6'>
          <div className='rounded border border-slate-100 bg-white p-6 shadow-sm sm:p-10'>
            <h2 className='mb-4 text-center text-xl font-bold text-slate-800 sm:text-right sm:text-2xl'>
              سلام دوست عزیز
            </h2>
            <p className='text-justify text-base leading-relaxed text-slate-600 sm:text-right sm:text-lg'>
              خوشحالیم که مجموعه <span className='font-bold text-blue-600'>مدمشاور</span> را برای
              مسیر آزمون دستیاری ۱۴۰۶ انتخاب کرده‌‌اید. همانطور که قبلا قول داده بودیم، دوستانی که
              در وبینار آمادگی برای دستیاری 1406 شرکت کرده‌اند، برای ورود به آزمون‌های 1406 تخفیف
              ویژه خواهند داشت.
            </p>

            <div className='mt-8 flex flex-col items-center gap-4 rounded border border-emerald-100 bg-emerald-50 p-4 sm:flex-row'>
              <div className='shrink-0 rounded-full bg-emerald-600 p-2 text-white'>
                <icons.CheckCircle />
              </div>
              <p className='text-center font-medium text-emerald-800 sm:text-right'>
                این تخفیف به صورت خودکار برای شما فعال شده است و نیاز به وارد کردن کد تخفیف نخواهید
                داشت.
              </p>
            </div>

            <div className='mt-4 flex items-center justify-center gap-2 text-sm font-bold text-rose-600 sm:justify-start sm:text-base'>
              <icons.Calendar />
              <p>حداکثر مهلت استفاده: جمعه ۲۴ بهمن</p>
            </div>
          </div>
        </section>

        <section>
          <WebinarForm />
        </section>

        {/* Video Section */}
        <section className='space-y-4'>
          <div className='flex items-center justify-center gap-3 px-2 sm:justify-start'>
            <span className='shrink-0 text-blue-600'>
              <icons.PlayCircle />
            </span>
            <h3 className='text-lg font-bold text-slate-800 sm:text-xl'>
              ویدیوی راهنمای ثبت نام و استفاده از تخفیف:
            </h3>
          </div>
          <div className='overflow-hidden rounded border-4 border-white bg-black shadow-xl sm:rounded-xl sm:border-8'>
            <div className='aspect-video w-full'>
              <iframe
                title='webinar-video'
                src='https://www.aparat.com/video/video/embed/videohash/npx865z/vt/frame'
                className='h-full w-full'
                allowFullScreen
              />
            </div>
          </div>
        </section>

        {/* Support & Tips */}
        <section className='grid gap-4 sm:grid-cols-2 sm:gap-6'>
          <div className='rounded bg-blue-600 p-6 text-white shadow-lg sm:p-8'>
            <h3 className='mb-4 flex items-center gap-2 text-lg font-bold'>
              <icons.MessageCircle />
              نیاز به راهنمایی دارید؟
            </h3>
            <div className='space-y-3 text-sm sm:text-base'>
              <p className='flex items-center gap-2'>
                <icons.ExternalLink />
                تلگرام:
                <a href='https://t.me/medmoshaver_admin' className=' hover:underline'>
                  t.me/medmoshaver_admin
                </a>
              </p>
              <p className='flex items-center gap-2'>
                <icons.Phone />
                تماس:
                <a href='tel:09934444831'>۰۹۹۳۴۴۴۴۸۳۱</a>
              </p>
            </div>
          </div>
          <div className='rounded border border-amber-200 bg-amber-50 p-6 sm:p-8'>
            <div className='text-sm leading-relaxed sm:text-base'>
              <p className='mb-1 block font-bold text-amber-700'>توجه:</p>
              <p>پس از ثبت نام، برای عضویت در کانال خصوصی به ادمین آزمون مدمشاور پیام دهید:</p>
              <p className='mt-2 flex items-center gap-2 text-black'>
                <icons.ExternalLink />
                <a
                  href='https://t.me/medmoshaver_exam_admin'
                  className='text-xs font-bold text-blue-700 sm:text-sm'
                >
                  t.me/medmoshaver_exam_admin
                </a>
              </p>
            </div>
          </div>
        </section>
        {/* Program Details */}
        <section className='space-y-8'>
          <div className='space-y-3 text-center'>
            <h3 className='px-4 text-xl font-black text-slate-800 sm:text-2xl'>
              برنامه آزمون‌های دستیاری ۱۴۰۶
            </h3>
            <p className='mx-auto max-w-xl px-4 text-sm text-slate-500 sm:text-base'>
              برنامه مدمشاور شامل دو فاز مکمل برای آمادگی حداکثری است.
            </p>
          </div>

          <div className='grid gap-4 sm:grid-cols-2 sm:gap-8'>
            <div className='relative rounded-xl border-t-4 border-blue-500 bg-white p-6 shadow-sm'>
              <div className='absolute top-2 left-4 select-none text-5xl font-black text-slate-100'>
                ۱
              </div>
              <h4 className='relative z-10 mb-3 text-lg font-bold text-blue-600'>فاز مقدماتی</h4>
              <p className='relative z-10 text-justify text-sm leading-relaxed text-slate-600 sm:text-base'>
                از زمان ثبت‌نام شروع می‌شود و تا اواسط اردیبهشت 1405 ادامه خواهد‌یافت. در این دوره
                شما به 31 آزمون تمرینی برای درس‌های مختلف دسترسی خواهید داشت که زمان آن‌ها منعطف است
                و براساس راهنمایی‌های کانال خصوصی آزمون می‌توانید برنامه ریزی کنید و در آزمون‌ها
                شرکت کنید. هدف از این فاز، یک دور مطالعه اولیه و ایجاد پایه‌ی درسی مناسب است.
              </p>
            </div>

            <div className='relative rounded-xl border-t-4 border-indigo-500 bg-white p-6 shadow-sm'>
              <div className='absolute top-2 left-4 select-none text-5xl font-black text-slate-100'>
                ۲
              </div>
              <h4 className='relative z-10 mb-3 text-lg font-bold text-indigo-600'>
                فاز آزمون‌های دو هفته‌ای
              </h4>
              <p className='relative z-10 text-justify text-sm leading-relaxed text-slate-600 sm:text-base'>
                از اواسط اردیبهشت 1405 شروع می‌شود و تا زمان آزمون دستیاری اردیبهشت 1406، شما در 27
                آزمون برنامه ریزی شده به فاصله هر دو هفته یکبار شرکت خواهید کرد. اولین آزمون در
                اوایل خرداد 1405 برگزار خواهد شد. همچنین 5 آزمون جامع در ماه منتهی به آزمون دستیاری
                برگزار خواهد شد.
              </p>
            </div>
          </div>

          <div className='rounded border-r-4 border-rose-500 bg-rose-50 p-4 sm:p-6'>
            <p className='text-center text-sm font-bold leading-relaxed text-rose-700 sm:text-lg'>
              با ورود به برنامه آزمون‌های مدمشاور، امکان 6 دور مطالعه تا آزمون دستیاری 1406 برای شما
              وجود خواهد داشت.
            </p>
          </div>
        </section>
        {/* Schedule Image */}
        <section>
          <p className='text-center text-xs font-medium italic text-slate-400 sm:text-sm'>
            برای مشاهده بزرگتر برنامه، روی تصویر زیر کلیک کنید:
          </p>
          <br />
          <h3 className=' mb-4 flex items-center justify-center gap-2 text-lg font-bold'>
            برنامه آزمون‌های دستیاری دوره 54 (گروه مد مشاور)
          </h3>
          <div className='group relative mx-auto max-w-2xl cursor-zoom-in'>
            <a href='#img-modal'>
              <div className='overflow-hidden rounded border-2 border-white shadow-lg transition-all group-hover:shadow-2xl'>
                <img
                  src={process.env.PUBLIC_URL + 'images/webinar-table.jpg'}
                  alt='جدول برنامه آزمون'
                  className='h-auto w-full'
                />
              </div>
            </a>
          </div>

          {/* Pure CSS Lightbox */}

          <div
            id='img-modal'
            className=' fixed inset-0 z-[100] hidden items-center justify-center
             overflow-hidden bg-slate-900/95 backdrop-blur-sm target:flex'
          >
            {/* backdrop */}
            <a href='#' className='absolute inset-0 cursor-zoom-out'></a>

            {/* modal content */}
            <div className='relative flex h-full w-full items-center justify-center p-4'>
              <img
                src={process.env.PUBLIC_URL + 'images/webinar-table.jpg'}
                alt='Full Schedule'
                className='max-h-[85vh] max-w-[95vw] rounded object-contain shadow-2xl'
              />

              {/* close button */}
              <a
                href='#'
                className='absolute top-4 left-4 flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-bold text-white backdrop-blur transition hover:bg-white/20'
              >
                ✕ بستن تصویر
              </a>
            </div>
          </div>
        </section>
        {/* Final CTA */}
        <section>
          <div className='mx-auto w-full'>
            <WebinarForm />
          </div>
        </section>
      </main>
    </div>
  );
};

export default Webinar;
